import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

function getStoredToken() {
  return localStorage.getItem('neon_token') || localStorage.getItem('token') || '';
}

function getStoredUser() {
  const raw = localStorage.getItem('neon_user');
  if (raw) {
    try { return JSON.parse(raw); } catch { /* fall through */ }
  }
  const token = getStoredToken();
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload;
    } catch { /* fall through */ }
  }
  return null;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => getStoredUser());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleExpired = () => setUser(null);
    window.addEventListener('neon-auth-expired', handleExpired);
    setLoading(false);
    return () => window.removeEventListener('neon-auth-expired', handleExpired);
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('neon_token', token);
    if (userData) {
      localStorage.setItem('neon_user', JSON.stringify(userData));
      setUser(userData);
    } else {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        localStorage.setItem('neon_user', JSON.stringify(payload));
        setUser(payload);
      } catch {
        setUser(null);
      }
    }
  };

  const logout = () => {
    localStorage.removeItem('neon_token');
    localStorage.removeItem('token');
    localStorage.removeItem('neon_user');
    setUser(null);
  };

  const isAdmin = user?.role === 'admin';
  const isStaff = ['admin', 'waiter', 'kitchen'].includes(user?.role);

  return (
    <AuthContext.Provider value={{ user, login, logout, isAdmin, isStaff, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
